import { configureStore } from "@reduxjs/toolkit";
// import topicChatReducer from "./reducers/TopicChatReducer";
import deliciousFilterTypeReducer from "./reducers/DeliciousFilterTypeReducer";
import viewTypeReducer from "./reducers/ViewTypeReducer";
import userVoteReducer from "./reducers/UserVoteReducer";

const reducer = {
  deliciousFilterType: deliciousFilterTypeReducer,
  viewType: viewTypeReducer,
  userVote: userVoteReducer,
};

const store = configureStore({
  reducer: reducer,
});

export default store;
